import { jsx as _jsx } from "react/jsx-runtime";
import s from './Button.module.css';
export function Button({ variant = 'primary', size = 'md', className, ...rest }) {
    return (_jsx("button", { ...rest, className: [s.base, s[variant], size === 'lg' && s.lg, className].filter(Boolean).join(' ') }));
}
